exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".with-card {\n  border: 1px solid #ccc;\n  height: auto;\n  padding: 20px 30px;\n  margin-bottom: 20px;\n  border-radius: 5px;\n  -webkit-box-shadow: 0px 3px 5px 0px #ccc;\n  box-shadow: 0px 3px 5px 0px #ccc; }\n  .with-card h4,\n  .with-card h5 {\n    color: var(--text-light-blue);\n    padding-bottom: 15px;\n    font-size: 22px; }\n  @media only screen and (max-width: 768px) {\n    .with-card {\n      padding: 15px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/withCard/withCard.scss
// module id = 856
// module chunks = 0